// inspired by https://usehooks.com/useOnClickOutside

import { useEffect } from "react";
import { HTMLElementRef } from "common/types/ElementRef";

/* `handler` should be memoised for best performance */
export function useOnClickOutside(
    ref: HTMLElementRef | HTMLElementRef[],
    handler: (event: TouchEvent | MouseEvent) => void,
    enable: boolean
) {
    useEffect(() => {
        const listener = (event: TouchEvent | MouseEvent) => {
            if (Array.isArray(ref)) {
                for (const r of ref) {
                    if (!r.current || r.current.contains(event.target as Node | null)) {
                        // click inside
                        return;
                    }
                }
            } else {
                if (!ref.current || ref.current.contains(event.target as Node | null)) {
                    // click inside
                    return;
                }
            }
            handler(event);
        };

        if (enable) {
            document.addEventListener("mousedown", listener);
            document.addEventListener("touchstart", listener);
        }

        return () => {
            document.removeEventListener("mousedown", listener);
            document.removeEventListener("touchstart", listener);
        };
    }, [ref, handler, enable]);
}
